import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <footer className='footer'>
        <div className='footer__contact'>
            <div className='foooter__contactLeftSection'>
                <h1>Contact</h1>
                <form>
                    
                </form>
            </div>
        </div>

        <div className='footer__icons'>

        </div>

        <div className='footer__copyright'>

        </div>


    </footer>
  )
}

export default Footer